import React, { useRef, useEffect, useState } from 'react';

import { className, Heading, Text, Row, Col } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';
import { useTranslate } from 'soluble-gatsby-source';
import style from './style.module.scss'

export default function CardFutureWebinarComponent({
    title,
    category,
    text,
    speakers,
    date,
    time,
    url,
    alternative,
    isFirstViewport,
    isEvent,
    venue,
    registerUrl,
    viewUrl,
    isFuture
}) {
    const translation = useTranslate();
    const wrapperRef = useRef();
    const [ isInFirstViewport, setIsInFirstViewport ] = useState(false);

    useEffect(
        () => {
            if (!isFirstViewport) {
                return;
            }
            
            if (wrapperRef && wrapperRef.current && wrapperRef.current.offsetTop < window.innerHeight) {
                setIsInFirstViewport(true);
            }
        },
        [ setIsInFirstViewport, wrapperRef, isFirstViewport ]
    );

    return (
        <div 
            ref={wrapperRef}
            {...className(`${style.wrapper} pt-${isEvent ? 4 : 3} pl-4 pr-4 pb-5 mb-4 pt-lg-5 pl-lg-5 mb-lg-2 ${alternative ? style['wrapper--alternative'] : ''}`)}
            data-sal="slide-up"
            data-sal-easing="ease-out-quart"
            data-sal-delay={isInFirstViewport ? 'xs-none--lg-1200' : ''}
        >
            <Row className="align-items-lg-center">
                <Col col={{ lg: alternative ? 3 : 2 }} className={style['col--date']}>
                    {!isEvent ? (
                        <Text
                            tag="span"
                            mb={{ xs: 2 }}
                            className={`${isEvent ? '' : 'text-uppercase'} ${style.tag} overline d-block d-lg-none`}
                        >
                            {isEvent && venue ? venue : (category && category.title ? category.title : '&nbsp;')}
                        </Text>
                    ) : null}
                    <Text
                        tag="p"
                        className={`h3 ${style.datetime} ${isEvent ? 'text-center text-lg-left' : ''}`}
                        mb={{ xs: isEvent ? 4 : 3, lg: 0 }}
                    >
                        {`<span>${date ? date.replace('.', '') : date}</span> <span>${time}</span>`}
                    </Text>
                </Col>
                <Col 
                    col={{
                        lg: alternative || isEvent ? 5 : 4,
                        xl: alternative || isEvent ? 6 : 5
                    }}
                >
                    <Text
                        tag="span"
                        mb={{ xs: alternative || isEvent ? 0 : 2 }}
                        className={`${isEvent ? '' : 'text-uppercase'} ${style.tag} overline d-none d-lg-block`}
                    >
                        {isEvent && venue ? venue : (category && category.title ? category.title : '&nbsp;')}
                    </Text>
                    <Heading
                        tag="h4"
                        className="h3 font-weight-bold"
                        mt={{ xs: isEvent ? 3 : 2, lg: alternative || isEvent ? 0 : 2 }}
                        mb={{ xs: isEvent ? 2 : 3, lg: isEvent ? 1 : 0 }}
                    >
                        {title}
                    </Heading>
                    {(alternative && speakers) || (isEvent && text) ? (
                        <Text
                            tag="div"
                            className={`${isEvent ? '' : 'd-none d-lg-block'} body`}
                            mb={{ xs: isEvent ? 3 : 0, lg: 0 }}
                        >
                            {isEvent ? text : speakers}
                        </Text>
                    ) : null}
                </Col>
                <Col 
                    col={{
                        lg: isEvent ? 2 : 3
                    }}
                    className={alternative ? 'd-lg-none' : ''}
                >
                    <Text
                        tag="div"
                        mb={{ xs: 8, lg: 0 }}
                        className={`body ${speakers ? 'font-weight-bold' : ''} ${isEvent ? 'd-none d-lg-block' : ''}`}
                    >
                        {speakers ? speakers : text}
                    </Text>
                </Col>
                <Col 
                    col={{
                        lg: alternative ? 4 : 3,
                        xl: alternative ? 3 : 2
                    }}
                >
                    <ButtonComponent
                        buttonClassName={style.button}
                        button={{
                            block: true,
                            detached: true,
                            externalLink: isEvent ? (registerUrl ? registerUrl : viewUrl) : url,
                            label: translation[isEvent ? 'events-section.event.next.cta' : 'webinars-section.webinar.next.cta'].text,
                            target: '_blank'
                        }}
                    />
                </Col>
            </Row>
        </div>
    );
}
